/* milchkindstories: drehbare Verpackung in 3D */
(function(){
  function start(){
    var wrap=document.getElementById('mks-b3'); if(!wrap) return;
    var sec = wrap.closest('.mks-b3') || document;
    var box=wrap.querySelector('.mks-b3-box'); if(!box) return;
    var seiten=[].slice.call(box.querySelectorAll('.mks-b3-seite'));
    var punkte=[].slice.call(sec.querySelectorAll('.mks-b3-punkt'));
    var elZaehler=sec.querySelector('.mks-b3-zaehler');
    var elTitel=sec.querySelector('.mks-b3-titel');
    var elSatz=sec.querySelector('.mks-b3-satz');
    var texte=[];
    try { texte=JSON.parse(wrap.dataset.texte||'[]'); } catch(e){}

    var winkel=0, index=0, zieht=false, startX=0, startWinkel=0;

    function tiefeSetzen(){
      seiten.forEach(function(s,i){
        var d=((i*90 + (winkel%360))%360+360)%360;
        var stufe = (d>45 && d<315) ? ((d>135 && d<225) ? 2 : 1) : 0;
        s.setAttribute('data-dunkel', stufe);
      });
    }
    function zeichnen(){
      box.style.transform='rotateX(-4deg) rotateY('+winkel+'deg)';
      tiefeSetzen();
    }
    function textSetzen(i){
      var t=texte[i]; if(!t) return;
      [elTitel, elSatz, elZaehler].forEach(function(el){ if(el) el.classList.add('aus'); });
      setTimeout(function(){
        if(elZaehler) elZaehler.textContent='Seite '+(i+1)+' von '+texte.length;
        if(elTitel) elTitel.textContent=t.titel;
        if(elSatz) elSatz.textContent=t.satz;
        [elTitel, elSatz, elZaehler].forEach(function(el){ if(el) el.classList.remove('aus'); });
      }, 320);
      punkte.forEach(function(p,k){ p.classList.toggle('sel', k===i); });
    }
    function zu(i){
      var n=seiten.length;
      var ziel=((i%n)+n)%n;
      var diff=ziel-index;
      if(diff>n/2) diff-=n;
      if(diff<-n/2) diff+=n;
      index=ziel;
      winkel-=diff*90;
      box.classList.remove('zieht');
      zeichnen(); textSetzen(index);
    }
    function einrasten(){
      var ziel=Math.round(winkel/90)*90;
      winkel=ziel;
      var n=seiten.length;
      index=((Math.round(-ziel/90)%n)+n)%n;
      box.classList.remove('zieht');
      zeichnen(); textSetzen(index);
    }

    function runter(e){
      zieht=true;
      startX=(e.touches?e.touches[0].clientX:e.clientX);
      startWinkel=winkel;
      box.classList.add('zieht');
    }
    function schieben(e){
      if(!zieht) return;
      var x=(e.touches?e.touches[0].clientX:e.clientX);
      var dx=x-startX;
      winkel=startWinkel+dx*0.45;
      zeichnen();
      if(e.cancelable && Math.abs(dx)>8) e.preventDefault();
    }
    function hoch(){ if(!zieht) return; zieht=false; einrasten(); }

    box.addEventListener('mousedown', runter);
    window.addEventListener('mousemove', schieben);
    window.addEventListener('mouseup', hoch);
    box.addEventListener('touchstart', runter, {passive:true});
    box.addEventListener('touchmove', schieben, {passive:false});
    box.addEventListener('touchend', hoch);

    var vor=sec.querySelector('.mks-b3-vor'), zurueck=sec.querySelector('.mks-b3-zurueck');
    if(vor) vor.addEventListener('click', function(){ zu(index+1); });
    if(zurueck) zurueck.addEventListener('click', function(){ zu(index-1); });
    punkte.forEach(function(p,k){ p.addEventListener('click', function(){ zu(k); }); });

    var gezeigt=false;
    function pruefen(){
      if(gezeigt) return;
      var r=wrap.getBoundingClientRect();
      if(r.top < (window.innerHeight||0)*0.8 && r.bottom>0){
        gezeigt=true;
        setTimeout(function(){ zu(index+1); }, 600);
        window.removeEventListener('scroll', pruefen);
      }
    }
    window.addEventListener('scroll', pruefen, {passive:true});
    setTimeout(pruefen, 300);

    zeichnen(); textSetzen(0);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
